export {};

// let counterOfInserts = 0;

$(document).on('click', '.js-add-template', function onClick(evt) {
    evt.preventDefault();

    const $button = $(this);
    const $formSection = $button.closest('.form-section');
    const $hiddenForms = $formSection.find('.row--form.hidden');

    if ($hiddenForms.length === 1) {
        $button.addClass('hidden');
    }

    if ($hiddenForms.length) {
        const $firstHidden = $hiddenForms.eq(0);
        const $parent = $firstHidden.parent();

        // ставим в конец
        $firstHidden.find('select').val('').trigger('change');
        $parent.append($firstHidden);

        $firstHidden.removeClass('hidden').addClass('animated fast pulse');

        setTimeout(() => {
            $firstHidden.removeClass('animated fast pulse');
        }, 800); // время в css
    }

    // const templateSelector = $button.data('template');
    // const method = $button.data('method');
    // const target = $button.data('target');
    // const emitEvent = $button.data('emit-event');

    // const $templateContainer = $(templateSelector);
    // const $target = $(target);

    // let template = $templateContainer.html();

    // const idValues = (template.match(/\sid="([a-z0-9-]+)"/gi) || []).map((str) =>
    //     str.replace(/\sid="([a-z0-9-]+)"/gi, '$1'),
    // );

    // idValues.forEach((id) => {
    //     const regEx = new RegExp(id, 'gi');

    //     template = template.replace(regEx, id + '-' + counterOfInserts++);
    // });

    // const $template = $(template);

    // if (template && method) {
    //     $template.addClass('animated fast pulse');
    //     $target[method]($template);

    //     $(window).trigger(emitEvent);

    //     setTimeout(() => {
    //         $template.removeClass('animated fast pulse');
    //     }, 1000);

    //     evt.preventDefault();
    // }
});



// WEBPACK FOOTER //
// ./js/main/module/add-template.js